// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__XkGLH","message":"NotFoundPage_message__OiRsn","link":"NotFoundPage_link__iZyh1","icon":"NotFoundPage_icon__P2ipy"};